module.exports = {
  LOCALPATH: 'LOCALPATH',
  GITPATH: 'GITPATH',
  GITURL: 'GITURL',
  GITBRANCH: 'GITBRANCH',
  GITDIR: 'GITDIR',
  GITPREPARECMD: 'GITPREPARECMD'
}
